import type { ZuubPayer } from '@/@types/zuub/contracts';

import { getPayerColorCombo } from '../helpers';

export const getPayerDisplayInfo = (payer: ZuubPayer | undefined) => {
  const payerName = payer?.name || 'Unknown Payer';
  const portalUrl = payer?.portalUrl;
  const colorCombo = getPayerColorCombo(payerName);
  const firstTwoLetters = getFirstTwoLetters(payerName);

  return {
    payerName,
    portalUrl,
    colorCombo,
    firstTwoLetters,
  };
};

export const getFirstTwoLetters = (payerName: string) => {
  const compact = (payerName || '').replace(/\s+/g, '');
  if (compact.length === 0) return '??';
  if (compact.length === 1) return compact.charAt(0).toUpperCase() + '?';
  return compact.charAt(0).toUpperCase() + compact.charAt(1).toLowerCase();
};
